export enum State {
  NoBooking = 'NoBooking',
  Pending = 'Pending',
  ActionSignIn = 'ActionSignIn',
  ActionSignInCasual = 'ActionSignInCasual',
  ActionSignOut = 'ActionSignOut',
  SignedIn = 'SignedIn',
  SignedOut = 'SignedOut',
}
